"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomType = void 0;
var RoomType;
(function (RoomType) {
    RoomType[RoomType["None"] = 0] = "None";
    RoomType[RoomType["Arena"] = 1] = "Arena";
    RoomType[RoomType["Beach"] = 2] = "Beach";
    RoomType[RoomType["Cemetery"] = 3] = "Cemetery";
    RoomType[RoomType["Circus"] = 4] = "Circus";
    RoomType[RoomType["CircusExterior"] = 5] = "CircusExterior";
    RoomType[RoomType["CrystalForest"] = 6] = "CrystalForest";
    RoomType[RoomType["Dungeon"] = 7] = "Dungeon";
    RoomType[RoomType["Graveyard"] = 8] = "Graveyard";
    RoomType[RoomType["Prairie"] = 9] = "Prairie";
    RoomType[RoomType["WaterfallForest"] = 10] = "WaterfallForest";
    RoomType[RoomType["Cave"] = 11] = "Cave";
    RoomType[RoomType["MangleboneTents"] = 12] = "MangleboneTents";
    RoomType[RoomType["MangleboneBridge"] = 13] = "MangleboneBridge";
    RoomType[RoomType["MangleboneKeepDoor"] = 14] = "MangleboneKeepDoor";
    RoomType[RoomType["XyriasDomain"] = 15] = "XyriasDomain";
    RoomType[RoomType["Orchard"] = 16] = "Orchard";
    RoomType[RoomType["TreasureRoom"] = 17] = "TreasureRoom";
    RoomType[RoomType["FightingPit"] = 18] = "FightingPit";
    RoomType[RoomType["CaedecusTower"] = 19] = "CaedecusTower";
    RoomType[RoomType["MangleboneKeep"] = 20] = "MangleboneKeep";
    RoomType[RoomType["CentaurSettlement"] = 21] = "CentaurSettlement";
    RoomType[RoomType["DiamondRock"] = 22] = "DiamondRock";
    RoomType[RoomType["VillageInterior"] = 23] = "VillageInterior";
    RoomType[RoomType["PirateShip"] = 24] = "PirateShip";
    RoomType[RoomType["SkullIsland"] = 25] = "SkullIsland";
    RoomType[RoomType["BridgeAway"] = 26] = "BridgeAway";
    RoomType[RoomType["ForestRoad"] = 27] = "ForestRoad";
    RoomType[RoomType["Lava"] = 28] = "Lava";
    RoomType[RoomType["VillageExterior"] = 29] = "VillageExterior";
    RoomType[RoomType["DarkTowerExterior1"] = 30] = "DarkTowerExterior1";
    RoomType[RoomType["DarkTowerExterior2"] = 31] = "DarkTowerExterior2";
    RoomType[RoomType["DarkTowerExterior3"] = 32] = "DarkTowerExterior3";
    RoomType[RoomType["BeachHamlet"] = 33] = "BeachHamlet";
    RoomType[RoomType["KillingFields"] = 34] = "KillingFields";
    RoomType[RoomType["KaboomRoom"] = 35] = "KaboomRoom";
    RoomType[RoomType["Dungeon1"] = 36] = "Dungeon1";
    RoomType[RoomType["Dungeon2"] = 37] = "Dungeon2";
    RoomType[RoomType["Dungeon3"] = 38] = "Dungeon3";
})(RoomType = exports.RoomType || (exports.RoomType = {}));
